<template>
  <div class="athome">
    <b-container fluid>
      <b-row class="h-100">
        <b-col cols="12" md="4" class="pl-5 leftcontent">
          <h6 class="my-0" style="color: grey">
            {{ $t("athome.jumbo_subtitle") }}
          </h6>
          <h2>{{ $t("athome.jumbo_title") }}</h2>
          <br />
          <h1 class="pageSubtitle">{{ $t("athome.jumbo_desc1") }}</h1>
          <h1 class="pageSubtitle">{{ $t("athome.jumbo_desc2") }}</h1>
          <b-button squared variant="outline-dark" class="mt-3 shadow" @click="goBack">
            {{ $t("common.goback") }}</b-button>
          <!-- <appt-button v-bind:color="'d'"/>    -->
        </b-col>

        <b-col cols="12" md="8" class="mycontainer-main m-borders">
          <div class="row my-3">
            <div class="col-sm-4 mt-2 mt-sm-0" v-for="(item, index) in data" :key="index">
              <AtHomeCard :img="require(`../assets/images/${item.img}`)" :title="item.name" :body="item.desc"
                :link="item.cta_link" :link_text="item.cta">
              </AtHomeCard>
            </div>
          </div>
          <!-- <div class="col-sm-4">
                            <b-card 
                            overlay
                            :img-src="require('../assets/images/athome_facial2.jpeg')"                                              
                            >
                            <b-card-title class="mt-3" style="font-weight: bold;"> {{facial.name}} </b-card-title>
                            <b-card-text> {{facial.desc}} </b-card-text>                            
                            <template v-slot:footer  >
                                <b-button squared style="background-color: black;" class="main-button"> Learn More</b-button>
                            </template>
</b-card>
</div>
</div>

<div class="row">
  <div class="col-sm-4">
    <b-card overlay :img-src="require('../assets/images/athome_facial2.jpeg')" text-variant="white">
      <b-card-title class="mt-3" style="font-weight: bold;"> {{facial.name}} </b-card-title>
      <b-card-text> {{facial.desc}} </b-card-text>
      <template v-slot:footer>
                                <b-button squared style="background-color: black;" class="main-button"> Learn More</b-button>
                            </template>
    </b-card>
  </div>
  <div class="col-sm-4">
    <b-card overlay :img-src="require('../assets/images/athome_facial2.jpeg')" text-variant="white">
      <b-card-title class="mt-3" style="font-weight: bold;"> {{facial.name}} </b-card-title>
      <b-card-text> {{facial.desc}} </b-card-text>
      <template v-slot:footer>
                                <b-button squared style="background-color: black;" class="main-button"> Learn More</b-button>
                            </template>
    </b-card>
  </div>

  <div class="col-sm-4">
    <b-card bg-variant="dark" text-variant="white">
      <b-card-title class="mt-3" style="font-weight: bold;"> {{facial.name}} </b-card-title>
      <b-card-text> {{facial.desc}} </b-card-text>
      <template v-slot:footer>
                                <b-button squared style="background-color: black;" class="main-button"> get started</b-button>
                            </template>
    </b-card>
  </div>
</div> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const enData = [
  {
    name: "At-home waxing experience",
    desc: "We provide you everything you need to have successful waxing results at home ",
    cta: "View Kit",
    cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
    img: "athome_waxing.png",
  },
  {
    name: "Accessories for the Home",
    desc: "Beautify your daily life",
    cta: "View Accessories",
    cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
    img: "athome_waxing.png",
  },
];

const frData = [
  {
    name: "Expérience d'épilation à la maison",
    desc: "Nous vous fournissons tout ce dont vous avez besoin pour obtenir des résultats à la maison",
    cta: "Choisissez votre ensemble",
    cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
    img: "athome_waxing.png",
  },
  {
    name: "Accessoires à la maison",
    desc: "Embellissez votre quotidien",
    cta: "Voir les accessoires",
    cta_link:
      "https://moncoachbeaute.ca/collections/produits-en-vedette/products/silvi-oreillers-anti-acne",
    img: "pillowcase.jpg",
  },
];

import AtHomeCard from "@/components/atHomeCard.vue";
export default {
  name: "athome",
  components: { AtHomeCard },
  data() {
    return {
      data: "",
    };
  },
  methods: {
    getImgUrl(p) {
      var images = require.context("../assets/images/", false, /\.jpg$/);
      return images("./" + p + ".jpg");
    },
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      if (this.$i18n.locale == "fr") {
        this.data = frData;
      } else this.data = enData;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  created() { },
  mounted() {
    this.getData();
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-img {
  width: 100%;
  max-height: 300px;
}

.mycontainer-main {
  min-height: 80vh;
}

.main-button {
  min-width: 175px;
  text-transform: uppercase;
}

.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
}

@media screen and (max-width: 600px) {
  .leftcontent {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/AtHome.vue